// create CRUD class with axios
import axios, {type AxiosResponse} from "axios";
import ThermalPrinterBase from "../../services/thermalPrinter/ThermalPrinterBase";
// import ThermalPrinterBase from "./ThermalPrinterBase";
import dayjs from "dayjs";
import _ from "lodash"



import PrintCustomNiceloopV1Builder from "~/class/printer/PrintCustomNiceloopV1Builder";
import { useFormatNumber } from "~/composables/useUtils";
import { buildProductSummaryByTypeFromSumProductType } from '~/utils/printerProductSummary'




export default class ThermalPrintProductSold extends ThermalPrinterBase {  

    //#FROM NICELOOP POS
    printProductSold(payload:any){   
        this.print_data = this.withPayload(payload)
        console.log('print_data', this.print_data)
         
        return this
    }    

    withPayload(payload:any){
             
        //Grouping product sold by type
        const grouped = payload.sumProductType
        const productSummaryData = buildProductSummaryByTypeFromSumProductType(grouped)

        const newPayload ={
            shopName:payload.store.name,
            employee:payload.employee,
            groups:grouped,
            productSoldSummary:productSummaryData,
            isFullReport:payload.isFullReport,
            isCloseShop:payload.isCloseShop,
            isChangeShift:payload.isChangeShift
        }

        const productSold =  new PrintCustomNiceloopV1Builder().makeProductSoldReport(newPayload).build();
        return productSold
    }

    setPayload(payload:any){
        this.print_data = payload
        return this
    }
}
